import type { Components } from '@mui/material/styles';

export default function MUIFormControl(): Components['MuiFormControl'] {
  return {};
}
